<header>
	<div class="container">
		<div class="title">JÁ USA ÓCULOS?</div>
		<div class="subtitle">ESTÁ NA HORA DE EXPERIMENTAR <br>LENTES DE CONTACTO - <span>GRÁTIS!</span></div>
		<p class="description">
			<span>Marque já uma avaliação GRATUITA<br>com um especialista</span>, sem compromisso,<br>e receba as suas
			primeiras lentes de contacto<br>totalmente gratuitas!
		</p>
		<p class="location">
			<span>Dia 19 de setembro</span>, na<br>nossa <span>Óptica em Matosinhos</span>.
		</p>
	</div>
</header>

<section class="appointment">
	<div class="container">
		<div class="title">Marque aqui a sua<br><span>Avaliação Gratuita</span></div>
		<form [formGroup]="appointmentForm">
			<div class="row">
				<div class="col col-md-8 offset-md-2">
					<input type="text" class="form-control form-control-lg" placeholder="Nome Completo"
						formControlName="name" />
					<input type="text" class="form-control form-control-lg" placeholder="E-mail"
						formControlName="email" />
					<input type="text" class="form-control form-control-lg" placeholder="Telefone"
						formControlName="phone" />
				</div>
			</div>
			<div class="row">
				<div class="col-md-4 offset-md-4 text-center">
					<button type="submit" class="btn btn-lg btn-light" [disabled]="appointmentForm.invalid"
						(click)="send()">
						Marcar Avaliação
					</button>
				</div>
			</div>
		</form>
		<p class="disclaimer">
			Os kits de iniciação serão entregues apenas a participantes inscritos que compareçam na avaliação.<br>
			Campanha válida exclusivamente no dia 19 de setembro, na nossa óptica em Matosinhos.
		</p>
	</div>
</section>


<section class="about">
	<div class="container">
		<div class="title">
			<div class="text">O QUE SÃO OS<br><span>DUAL DAYS?</span></div>
			<div class="image"></div>
		</div>
		<div class="feature">Os Alcon Dual Days são uma campanha especial<br>que promove a utilização combinada de
			óculos e<br>lentes de
			contacto.</div>
		<p class="description">Se sempre teve curiosidade, mas nunca experimentou lentes de<br>contacto, esta é a
			oportunidade ideal para experimentar — de forma<br>100% gratuita.</p>
	</div>
</section>

<section class="benefits">
	<div class="container">
		<div class="alcon">
			<div class="woman"></div>
		</div>
		<div class="title">BENEFÍCIOS<br><span>EM DESTAQUE</span></div>
		<div class="box">
			<div class="row">
				<div class="col-md-4 mb-5">
					<div class="card">
						<div class="card-body">
							<div class="card-icon icon-1"></div>
							<div class="card-title">
								<div>Avaliação<br>Gratuita</div>
							</div>
							<div class="card-description">Consulta com um especialista em lentes de contacto — sem
								compromisso.</div>
						</div>
					</div>
				</div>
				<div class="col-md-4 mb-5">
					<div class="card">
						<div class="card-body">
							<div class="card-icon icon-2"></div>
							<div class="card-title">
								<div><span>Oferta</span><br>de Lentes de<br>Contacto</div>
							</div>
							<div class="card-description">Receba um kit de iniciação com lentes para experimentar no
								próprio dia.</div>
						</div>
					</div>
				</div>
				<div class="col-md-4 mb-5">
					<div class="card">
						<div class="card-body">
							<div class="card-icon icon-3"></div>
							<div class="card-title">
								<div>Acompanhamento<br>Profissional</div>
							</div>
							<div class="card-description">Esclareça todas as suas dúvidas com acompanhamento
								personalizado.</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<footer>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-md-8 lince text-center text-md-end">
				<div class="logo">
					<img src="/assets/landing/lince-logo.png" class="img-fluid">
				</div>
			</div>
			<div class="col-12 col-md-4 alcon text-center text-md-start">
				<div class="logo">
					<img src="/assets/landing/alcon-logo.png" class="img-fluid">
				</div>
			</div>
		</div>
	</div>
</footer>